import CardHeaderImage from './CardHeaderImage';

export default CardHeaderImage;
